
define('ldsh!modules/lp_leads/templates/lead_listing_popup', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-overlay-container popUp-leads">\n  <!-- header -->\n  <div class="ed-opt-toolbar ed-modal-header">\n    <h4 class="ed-modal-title" data-i18n="integration.integrationsPopupTitle">Resultado de las Integraciones</h4>\n\n    <button data-dismiss="modal" class="close js-close" type="button" aria-hidden="true">\n      <i class="ri-close-line"></i>\n    </button>\n  </div>\n\n  <!-- contenido -->\n  <div class="ed-opt-content ed-modal-content">\n\n    <ul class="ed-leads-list js-integration-list">\n    ';
 for (var i=0; i < availableIntegrations.length; i++) { 
      var integration = availableIntegrations[i];
      if (hasIntegration(integration)) {
    ;
__p += '\n    <li class="ed-leads-list-item ' +
((__t = ( isActive(integration)? 'active-lead' : 'inactive-lead')) == null ? '' : __t) +
' ' +
((__t = ( isTracking(integration) && 'active-tracking' )) == null ? '' : __t) +
'">\n      <b class="lead-title">\n        <span data-i18n="integration.' +
((__t = ( integration )) == null ? '' : __t) +
'">Integracion</span>\n        ';
 if (isTracking(integration)) {;
__p += '\n        <small class="active-tracking-txt">tracking</small>\n        ';
 } ;
__p += '\n      </b>\n      <span class="lead-info">' +
((__t = ( getResponse(integration) )) == null ? '' : __t) +
'</span>\n      </li>\n    ';
 }
    } ;
__p += '\n    </ul>\n\n  </div>\n\n  <!-- botonera -->\n  <div class="ed-opt-btnbar ed-modal-footer">\n    <button data-i18n="" type="button" class="ed-btn ed-btn-sec js-close" data-i18n="common.okButton">Aceptar</button>\n  </div>\n\n</div>\n';

}
return __p
};});

